import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/content-destinations/get/summary.ts
var summary_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var AudioRepresentationSchema = z.object({
	bandwidth: z.number(),
	channels: z.number(),
	codecs: z.string(),
	id: z.number()
});
var VideoRepresentationSchema = z.object({
	bandwidth: z.number(),
	codecs: z.string(),
	frameRate: z.string(),
	height: z.number(),
	id: z.number(),
	width: z.number()
});
var ResponseSchema = z.object({
	audioAdaptationSets: z.array(z.object({
		id: z.number(),
		representations: z.array(AudioRepresentationSchema)
	})),
	hevc: z.boolean(),
	live: z.boolean(),
	quickTimeCompatible: z.boolean(),
	videoAdaptationSets: z.array(z.object({
		id: z.number(),
		representations: z.array(VideoRepresentationSchema)
	}))
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { summary_exports };

//# sourceMappingURL=summary.js.map